import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseIconComponent } from '../iconbase';

@Component({
  selector: 'sof-check-icon',
  templateUrl: '../icon.template.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckComponent extends BaseIconComponent {
  constructor() {
    super('check');
  }
}
